<template>
  <div class="menu-main">
    <el-menu
        class="el-menu-vertical-demo"
        :collapse="getIsOpenCloseManu"
        background-color="#f8fbff"
        text-color="#5f6f8f"
        active-text-color="#2f436d"
        :unique-opened="true"
        :default-active="activeMenuIndex"
        :default-openeds="openSubMenu"
        @select="handleMenuSelect"
    >
      <router-link to="/dashboard" class="router-link">
        <el-menu-item index="1" class="menu-logo-item">
          <i class="el-icon-s-home menu-logo-icon"></i>
          <span slot="title" class="onekids-title">ONEKIDS PLUS</span>
        </el-menu-item>
      </router-link>
      <el-submenu index="2" class="menu-group-news"
                  v-if="checkPermission(['news'])"
      >
        <template #title>
          <i class="el-icon-notebook-2"/>
          <span class="title_nav">
            Bảng tin
            <span class="title_nav_indicator" v-if="parentFeedback > 0 || teacherFeedback > 0">
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>
        <router-link to="/appsend/notification" class="router-link">
          <el-menu-item
              v-if="checkPermission(['news_notifySystem'])"
              index="2-1"
              @click="changeBreadcrumbMethod('appsend-notification')"
          >Thông báo hệ thống
          </el-menu-item
          >
        </router-link>
        <router-link to="/notifihis/notify-school" class="router-link">
          <el-menu-item
              index="2-2"
              @click="changeBreadcrumbMethod('notifihis-notify-school')"
          >Tin tức nhà trường
          </el-menu-item
          >
        </router-link>
        <router-link to="/appsend/parent-feedback" class="router-link">
          <el-menu-item
              v-if="checkPermission(['news_feedbackParent'])"
              index="2-3"
              @click="changeBreadcrumbMethod('appsend-parent-feedback')"
          >
            <div class="wrap_title_nav">
              <span>Phụ huynh góp ý</span>
              <div v-if="parentFeedback > 0" class="notification_nav">{{ parentFeedback }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/appsend/teacher-feedback" class="router-link">
          <el-menu-item
              index="2-4"
              v-if="checkPermission(['news_feedbackTeacher'])"
              @click="changeBreadcrumbMethod('appsend-teacher-feedback')"
          >
            <div class="wrap_title_nav">
              <span>Giáo viên góp ý</span>
              <div v-if="teacherFeedback > 0" class="notification_nav">{{ teacherFeedback }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/survey_form/manager" class="router-link">
          <el-menu-item
              index="2-5"
              v-if="checkPermission(['news_survey'])"
              @click="changeBreadcrumbMethod('survey-form-manager')"
          >
            Phiếu khảo sát
          </el-menu-item>
        </router-link>
      </el-submenu>
      <el-submenu index="3" class="menu-group-diary">
        <template #title>
          <i class="el-icon-reading"/>
          <span class="title_nav">
            Nhật ký phụ huynh
            <span class="title_nav_indicator"
                  v-if="parentMessage > 0 || medicationInstructions > 0 || leaveStudent > 0"
            >
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>
        <router-link to="/parentdiary/message-parent" class="router-link">
          <el-menu-item
              index="3-1"
              v-if="checkPermission(['parentDiary_message'])"
              @click="changeBreadcrumbMethod('parentdiary-message-parent')"
          >
            <div class="wrap_title_nav">
              <span>Lời nhắn</span>
              <div v-if="parentMessage > 0" class="notification_nav">{{ parentMessage }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/parentdiary/medicine" class="router-link">
          <el-menu-item
              index="3-2"
              v-if="checkPermission(['parentDiary_medicine'])"
              @click="changeBreadcrumbMethod('parentdiary-medicine')"
          >
            <div class="wrap_title_nav">
              <span>Dặn thuốc</span>
              <div v-if="medicationInstructions > 0" class="notification_nav">{{ medicationInstructions }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/parentdiary/take-leave" class="router-link">
          <el-menu-item
              index="3-3"
              v-if="checkPermission(['parentDiary_absenLetter'])"
              @click="changeBreadcrumbMethod('parentdiary-take-leave')"
          >
            <div class="wrap_title_nav">
              <span>Xin nghỉ</span>
              <div v-if="leaveStudent > 0" class="notification_nav">{{ leaveStudent }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/absent_letter/daily" class="router-link">
          <el-menu-item
              index="3-4"
              v-if="checkPermission(['absent_letter_v4'])"
              @click="changeBreadcrumbMethod('absent-letter_v4')"
          >
            <div class="wrap_title_nav">
              <span>Xin nghỉ</span>
              <div v-if="leaveStudent > 0" class="notification_nav">{{ leaveStudent }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu index="4" class="menu-group-staff">
        <template #title>
          <i class="el-icon-user"/>
          <span>Quản lý nhân sự</span>
        </template>
        <router-link to="/employee/department" class="router-link">
          <el-menu-item
              index="4-1"
              v-if="checkPermission(['infoEmployee_department'])  "
              @click="changeBreadcrumbMethod('employee-department')"
          >Danh sách phòng ban
          </el-menu-item
          >
        </router-link>
        <router-link to="/employee/employees" class="router-link">
          <el-menu-item
              v-if="      checkPermission(['infoEmployee_list'])   "
              index="4-2"
              @click="changeBreadcrumbMethod('employee-employees')"
          >Danh sách nhân sự
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu index="5" class="menu-group-student">
        <template #title>
          <i class="el-icon-user-solid"/>
          <span>Quản lý học sinh</span>
        </template>
        <router-link to="/student/grade" class="router-link">
          <el-menu-item
              index="5-1"
              v-if="checkPermission(['kids_grade'])"
              @click="changeBreadcrumbMethod('student-grade')"
          >Danh sách khối
          </el-menu-item
          >
        </router-link>
        <router-link to="/student/class" class="router-link">
          <el-menu-item
              v-if="checkPermission(['kids_class'])"
              index="5-2"
              @click="changeBreadcrumbMethod('student-class')"
          >Danh sách lớp
          </el-menu-item
          >
        </router-link>
        <router-link to="/student/students" class="router-link">
          <el-menu-item
              v-if="checkPermission(['kids_list'])"
              index="5-3"
              @click="changeBreadcrumbMethod('student-students')"
          >Danh sách học sinh
          </el-menu-item
          >
        </router-link>
        <router-link to="/parent/manager" class="router-link">
          <el-menu-item
              v-if="checkPermission(['kids_list'])"
              index="5-4"
              @click="changeBreadcrumbMethod('parent_manager')"
          >
            Danh sách phụ huynh
          </el-menu-item
          >
        </router-link>
        <router-link to="/student/students-group" class="router-link">
          <el-menu-item
              index="5-5"
              v-if="checkPermission(['kids_group'])"
              @click="changeBreadcrumbMethod('student-students-group')"
          >Nhóm học sinh
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['kids_transfer'])"
            to="/student/students-transfer"
            class="router-link"
        >
          <el-menu-item index="5-6" @click="changeBreadcrumbMethod('student-students-transfer')"
          >Thông tin mở rộng
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu index="6" class="menu-group-quality">
        <template #title>
          <i class="el-icon-document-checked"/>
          <span class="title_nav">
            Chất lượng học sinh
            <span class="title_nav_indicator"
                  v-if="commentStudent > 0 || pictureAlbum > 0 || heightWeight > 0"
            >
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>
        <router-link to="/student-quality/attendance" class="router-link">
          <el-menu-item
              v-if="checkPermission(['studentQuality_attendance'])"
              index="6-1"
              @click="changeBreadcrumbMethod('student-quality-attendance')"
          >Điểm danh
          </el-menu-item
          >
        </router-link>
        <router-link to="/student-quality/attendance/v2" class="router-link">
          <el-menu-item
              v-if="checkPermission(['studentQuality_attendance_v2'])"
              index="6-2"
              @click="changeBreadcrumbMethod('student-quality-attendance_v2')"
          >Điểm danh
          </el-menu-item
          >
        </router-link>
        <router-link to="/attendance/daily" class="router-link">
          <el-menu-item
              v-if="checkPermission(['attendance_v4'])"
              index="6-3"
              @click="changeBreadcrumbMethod('attendance-v4')"
          >Điểm danh
          </el-menu-item
          >
        </router-link>
        <router-link to="/student-quality/attendance-class-v3" class="router-link">
          <el-menu-item
              v-if="checkPermission(['attendance-class-v3'])"
              index="6-4"
              @click="changeBreadcrumbMethod('attendance-class-v3')"
          >Điểm danh theo lớp
          </el-menu-item
          >
        </router-link>
        <router-link to="/student-quality/attendance-group-v3" class="router-link">
          <el-menu-item
              v-if="checkPermission(['attendance-group-v3'])"
              index="6-5"
              @click="changeBreadcrumbMethod('attendance-group-v3')"
          >Điểm danh theo nhóm
          </el-menu-item
          >
        </router-link>
        <router-link to="/student-quality/evaluate" class="router-link">
          <el-menu-item
              v-if="checkPermission(['studentQuality_evaluate'])"
              index="6-6"
              @click="changeBreadcrumbMethod('student-quality-evaluate')"
          >
            <div class="wrap_title_nav">
              <span>Nhận xét</span>
              <div v-if="commentStudent > 0" class="notification_nav">{{ commentStudent }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/evaluation-v4" class="router-link">
          <el-menu-item
              v-if="checkPermission(['student-evaluation-v4'])"
              index="6-7"
              @click="changeBreadcrumbMethod('student-evaluation-v4')"
          >
            <div class="wrap_title_nav">
              <span>Nhận xét</span>
              <div v-if="commentStudent > 0" class="notification_nav">{{ commentStudent }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/album-v2" class="router-link">
          <el-menu-item
              index="6-8"
              v-if="checkPermission(['studentQuality_ablum'])"
              @click="changeBreadcrumbMethod('student-quality-album')"
          >
            <div class="wrap_title_nav">
              <span>Album ảnh</span>
              <div v-if="pictureAlbum > 0" class="notification_nav">{{ pictureAlbum }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/student-quality/height-weight" class="router-link">
          <el-menu-item
              index="6-9"
              v-if="checkPermission(['studentQuality_heightWeight'])"
              @click="changeBreadcrumbMethod('student-quality-height-weight')"
          >
            <div class="wrap_title_nav">
              <span>Chiều cao, cân nặng</span>
              <div v-if="heightWeight > 0" class="notification_nav">{{ heightWeight }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/student-quality/schedule" class="router-link">
          <el-menu-item
              index="6-10"
              v-if="checkPermission(['studentQuality_schedule'])"
              @click="changeBreadcrumbMethod('student-quality-schedule')"
          >Thời khóa biểu
          </el-menu-item
          >
        </router-link>
        <router-link to="/student-quality/class-menu" class="router-link">
          <el-menu-item
              index="6-11"
              v-if="checkPermission(['studentQuality_menu'])"
              @click="changeBreadcrumbMethod('student-quality-class-menu')"
          >Thực đơn
          </el-menu-item
          >
        </router-link>
        <router-link to="/student-quality/lifecycle" class="router-link">
          <el-menu-item
              index="6-12"
              v-if="checkPermission(['studentQuality_lifecycle', 'kids_list'])"
              @click="changeBreadcrumbMethod('student-quality-lifecycle')"
          >Lịch sử học sinh
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu index="8" class="menu-group-fees" v-if="checkPermission(['fees']) & (checkPermission(['fees_order']) || checkPermission(['fees_2_excel']))">
        <template #title>
          <i class="el-icon-money"/>
          <span class="title_nav">
            Học phí &amp; dịch vụ
            <span class="title_nav_indicator"
                  v-if="tuitionClass > 0 || tuitionGroup > 0"
            >
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>

        <router-link
            to="/finace/fees/order"
            v-if="checkPermission(['fees_order'])"
            class="router-link">
          <el-menu-item
              index="8-1"
              @click="changeBreadcrumbMethod('finace-fees-order')"
          >Thu học phí
          </el-menu-item
          >
        </router-link>

        <router-link
            to="/finace/fees/approved/advance"
            v-if="checkPermission(['fees_approved_advance'])"
            class="router-link">
          <el-menu-item
              index="8-2"
              @click="changeBreadcrumbMethod('finace-fees-approved-advance')"
          >Duyệt nâng cao
          </el-menu-item>
        </router-link>

        <router-link
            to="/finace/fees/approved"
            v-if="checkPermission(['fees_approved'])"
            class="router-link">
          <el-menu-item
              index="8-3"
              @click="changeBreadcrumbMethod('finace-fees-approved')"
          >Duyệt học phí
          </el-menu-item>
        </router-link>

        <router-link
            to="/finace/fees/package-kids"
            v-if="checkPermission(['fees_kidsPackage'])"
            class="router-link">
          <el-menu-item
              index="8-4"
              @click="changeBreadcrumbMethod('finace-fees-package-kids')"
          >Đăng ký khoản
          </el-menu-item>
        </router-link>

        <router-link
            to="/finace/fees/package"
            v-if="checkPermission(['fees_package'])"
            class="router-link">
          <el-menu-item
              index="8-5"
              @click="changeBreadcrumbMethod('finace-fees-package')"
          >Danh sách khoản
          </el-menu-item>
        </router-link>

        <router-link
            to="/finace/fees/wallet"
            v-if="checkPermission(['fees_wallet'])"
            class="router-link">
          <el-menu-item
              index="8-6"
              @click="changeBreadcrumbMethod('finace-fees-wallet')"
          >Quản lý ví
          </el-menu-item>
        </router-link>

        <router-link
            class="router-link"
            v-if="checkPermission(['fees_2_excel'])"
            to="/finance/v2">
          <el-menu-item
              index="8-7"
              @click="changeBreadcrumbMethod('finance-fees-order-excel')"
          >
            <div class="wrap_title_nav">
              <span>Thu học phí theo lớp</span>
              <div v-if="tuitionClass > 0" class="notification_nav">{{ tuitionClass }}</div>
            </div>
          </el-menu-item
          >
        </router-link>

        <router-link
            class="router-link"
            to="/finance/tuition-group-by-excel"
            v-if="checkPermission(['fees_2_group'])">
          <el-menu-item
              index="8-8"
              @click="changeBreadcrumbMethod('finance-fees-order-excel-group')"
          >
            <div class="wrap_title_nav">
              <span>Thu học phí theo nhóm</span>
              <div v-if="tuitionGroup > 0" class="notification_nav">{{ tuitionGroup }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <el-submenu index="8-19" v-if="checkPermission(['fees_2_excel'])">
          <template #title>Khởi tạo học phí</template>
          <router-link to="/finance/manage/initialize-class-tuition" class="router-link">
            <el-menu-item
                index="8-9-1"
                @click="changeBreadcrumbMethod('finance-manage-initialize-class-tuition')"
            >Duyệt khoản học phí lớp
            </el-menu-item
            >
          </router-link>
          <router-link to="/finance/manage/initialize-group-tuition" class="router-link">
            <el-menu-item
                index="8-9-2"
                @click="changeBreadcrumbMethod('finance-manage-initialize-group-tuition')"
            >Duyệt khoản học phí nhóm
            </el-menu-item
            >
          </router-link>
          <router-link to="/finance/manage/register-revenue" class="router-link">
            <el-menu-item
                index="8-9-3"
                @click="changeBreadcrumbMethod('finance-manage-register-revenue')"
            >Đăng ký khoản
            </el-menu-item
            >
          </router-link>
          <router-link to="/finance/manage/tuition-management" class="router-link">
            <el-menu-item
                index="8-9-4"
                @click="changeBreadcrumbMethod('finance-manage-tuition-management')"
            >Danh sách khoản
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <router-link
            class="router-link"
            v-if="checkPermission(['fees_2_finance_tuition_statistics'])"
            to="/finance/tuition-statistics">
          <el-menu-item
              index="8-10"
              @click="changeBreadcrumbMethod('finance-tuition-statistics')"
          >Thống kê học phí
          </el-menu-item
          >
        </router-link>

        <router-link
            v-if="checkPermission(['fees_2_finance_tuition_statistics'])"
            class="router-link"
            to="/finance/tuition-statistics/charts">
          <el-menu-item
              index="8-11"
              @click="changeBreadcrumbMethod('finance-tuition-statistics-charts')"
          >
            Biểu đồ thống kê
          </el-menu-item>
        </router-link>

        <router-link
            v-if="checkPermission(['fees_2_manager_tuition'])"
            class="router-link"
            to="/finance/manage/packages">
          <el-menu-item
              index="8-12"
              @click="changeBreadcrumbMethod('finance-manage-packages')"
          >
            Quản lý học phí gói
          </el-menu-item>
        </router-link>

      </el-submenu>
      <el-submenu index="20" class="menu-group-fees" v-if="checkPermission(['tuition_fees_services_v4'])">
        <template #title>
          <i class="el-icon-money"/>
          <span class="title_nav">
            Học phí &amp; dịch vụ
            <span class="title_nav_indicator" v-if="tuitionV4 > 0">
              <span class="hue_dot_notification"></span>
              <span class="dot_notification"></span>
            </span>
          </span>
        </template>

        <router-link class="router-link" to="/finance/manage-v3/student-invoices">
          <el-menu-item
              v-if="checkPermission(['tuition_v4'])"
              index="20-1"
              @click="changeBreadcrumbMethod('finance-manage-v3-student-invoices')"
          >
            <div class="wrap_title_nav">
              <span>Thu học phí</span>
              <div v-if="tuitionV4 > 0" class="notification_nav">{{ tuitionV4 }}</div>
            </div>
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/draft-invoice">
          <el-menu-item
              v-if="checkPermission(['tuition_manage_v4'])"
              index="20-2"
              @click="changeBreadcrumbMethod('finance-manage-v3-draft-invoice')"
          >Duyệt học phí
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/managing-revenue">
          <el-menu-item
              v-if="checkPermission(['tuition_manage_v4'])"
              index="20-3"
              @click="changeBreadcrumbMethod('finance-manage-v3-managing-revenue')"
          >Đăng ký khoản sử dụng
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/revenue-scopes">
          <el-menu-item
              v-if="checkPermission(['tuition_manage_v4'])"
              index="20-4"
              @click="changeBreadcrumbMethod('finance-manage-v3-revenue-scopes')"
          >Đăng ký  lớp/nhóm/gói
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/total-revenues">
          <el-menu-item
              v-if="checkPermission(['tuition_manage_v4'])"
              index="20-5"
              @click="changeBreadcrumbMethod('finance-manage-v3-total-revenues')"
          >Danh sách khoản chính
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/principal-revenues">
          <el-menu-item
              v-if="checkPermission(['tuition_manage_v4']) && checkPermission(['initialize-sub-account'])"
              index="20-6"
              @click="changeBreadcrumbMethod('finance-manage-v3-principal-revenues')"
          >Danh sách khoản phụ
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/packages">
          <el-menu-item
              v-if="checkPermission(['tuition_manage_v4'])"
              index="20-7"
              @click="changeBreadcrumbMethod('finance-manage-v3-packages')"
          >Danh sách gói học phí
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/tuition-statistics">
          <el-menu-item
              v-if="checkPermission(['tuition_statistics_v4'])"
              index="20-8"
              @click="changeBreadcrumbMethod('finance-manage-v3-tuition-statistics')"
          >Thống kê phiếu thu
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/tuition-statistics/charts">
          <el-menu-item
              v-if="checkPermission(['tuition_chart_v4'])"
              index="20-9"
              @click="changeBreadcrumbMethod('finance-manage-v3-tuition-statistics-charts')"
          >Biểu đồ thống kê
          </el-menu-item>
        </router-link>

        <router-link class="router-link" to="/finance/manage-v3/student-invoice-summary">
          <el-menu-item
              v-if="checkPermission(['tuition_v4'])"
              index="20-10"
              @click="changeBreadcrumbMethod('finance-manage-v3-student-invoice-summary')"
          >Tổng hợp phiếu thu
          </el-menu-item>
        </router-link>

      </el-submenu>
      <el-submenu index="9" class="menu-group-salary">
        <template #title>
          <i class="el-icon-coin"/>
          <span class="title_nav">
            Công lương
            <span class="title_nav_indicator"
                  v-if="payroll > 0"
            >
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>

        <router-link to="/finace/salary/paid" class="router-link">
          <el-menu-item
              index="9-1"
              v-if="checkPermission(['salary_order'])"
              @click="changeBreadcrumbMethod('finace-salary-paid')"
          >Thanh toán lương
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/salary/approved" class="router-link">
          <el-menu-item
              index="9-2"
              v-if="checkPermission(['salary_approved'])"
              @click="changeBreadcrumbMethod('finace-salary-approved')"
          >Duyệt bảng lương
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/salary/institute" class="router-link">
          <el-menu-item
              index="9-3"
              v-if="checkPermission(['salary_setting'])"
              @click="changeBreadcrumbMethod('finace-salary-institute')"
          >Thiết lập tiền lương
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/salary/sample" class="router-link">
          <el-menu-item
              index="9-4"
              v-if="checkPermission(['salary_sample'])"
              @click="changeBreadcrumbMethod('finace-salary-sample')"
          >Mẫu công lương
          </el-menu-item
          >
        </router-link>
        <router-link to="/finance/employee/salary/new" class="router-link">
          <el-menu-item
              index="9-5"
              v-if="checkPermission(['salary_new_excel'])"
              @click="changeBreadcrumbMethod('finance-employee-salary-new')"
          >
            <div class="wrap_title_nav">
              <span>Bảng lương</span>
              <div v-if="payroll > 0" class="notification_nav">{{ payroll }}</div>
            </div>
          </el-menu-item>
        </router-link>

        <router-link to="/finance/salary/statistical" class="router-link">
          <el-menu-item
              index="9-6"
              v-if="checkPermission(['salary_new_excel_statistics'])"
              @click="changeBreadcrumbMethod('finance-salary-statistical')"
          >Thống kê công lương
          </el-menu-item>
        </router-link>
        <router-link to="/finance/employee/static-salary/new" class="router-link">
          <el-menu-item
              index="9-7"
              v-if="checkPermission(['salary_new_excel_chart_view'])"
              @click="changeBreadcrumbMethod('finance-employee-static-salary-new')"
          >Biểu đồ công lương
          </el-menu-item>
        </router-link>
      </el-submenu>
      <el-submenu index="10" class="menu-group-attendance">
        <template #title>
          <i class="el-icon-document-checked"/>
          <span class="title_nav">
            Chấm công
            <span class="title_nav_indicator"
                  v-if="leavePersonnel > 0"
            >
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>
        <router-link to="/finace/salary/absent" class="router-link">
          <el-menu-item
              index="10-1"
              v-if="checkPermission(['attendanceEmployee_absentTeacher'])"
              @click="changeBreadcrumbMethod('finace-salary-absent')"
          >
            <div class="wrap_title_nav">
              <span>Xin nghỉ nhân sự</span>
              <div v-if="leavePersonnel > 0" class="notification_nav">{{ leavePersonnel }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/salary/attendance" class="router-link">
          <el-menu-item
              index="10-2"
              v-if="checkPermission(['attendanceEmployee_attendance'])"
              @click="changeBreadcrumbMethod('finace-salary-attendance')"
          >Chấm công nhân viên
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/salary/attendance-employee-v3" class="router-link">
          <el-menu-item
              index="10-3"
              v-if="checkPermission(['attendance-employee-v3'])"
              @click="changeBreadcrumbMethod('attendance-employee-v3')"
          >Chấm công nhân viên
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/salary/attendance-config" class="router-link">
          <el-menu-item
              index="10-4"
              v-if="checkPermission(['attendanceEmployee_config'])"
              @click="changeBreadcrumbMethod('finace-salary-attendance-config')"
          >Thiết lập chấm công
          </el-menu-item>
        </router-link>

      </el-submenu>
      <el-submenu index="11" class="menu-group-cash">
        <template #title>
          <i class="el-icon-suitcase-1"/>
          <span class="title_nav">
            Thu chi nội bộ
            <span class="title_nav_indicator"
                  v-if="paymentVouchers > 0 || receipts > 0"
            >
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>

        <router-link to="/finace/cashinternal/paymoney" class="router-link">
          <el-menu-item
              index="11-1"
              v-if="checkPermission(['cashInternal_out'])"
              @click="changeBreadcrumbMethod('finace-cashinternal-paymoney')"
          >
            <div class="wrap_title_nav">
              <span>Quản lý phiếu chi</span>
              <div v-if="paymentVouchers > 0" class="notification_nav">{{ paymentVouchers }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/cashinternal/collectmoney" class="router-link">
          <el-menu-item
              index="11-2"
              v-if="checkPermission(['cashInternal_in'])"
              @click="changeBreadcrumbMethod('finace-cashinternal-collectmoney')"
          >
            <div class="wrap_title_nav">
              <span>Quản lý phiếu thu</span>
              <div v-if="receipts > 0" class="notification_nav">{{ receipts }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/cashinternal/cashbook" class="router-link">
          <el-menu-item
              index="11-3"
              v-if="checkPermission(['cashInternal_cashbook'])"
              @click="changeBreadcrumbMethod('finace-cashinternal-cashbook')"
          >Quản lý quỹ
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/cashinternal/peopletype" class="router-link">
          <el-menu-item
              v-if="checkPermission(['cashInternal_people'])"
              index="11-4"
              @click="changeBreadcrumbMethod('finace-cashinternal-peopletype')"
          >Danh sách đối tượng
          </el-menu-item
          >
        </router-link>
        <router-link to="/finace/cashinternal/bankinfo" class="router-link">
          <el-menu-item
              v-if="checkPermission(['cashInternal_bank'])"
              index="11-5"
              @click="changeBreadcrumbMethod('finace-cashinternal-bankinfo')"
          >Thông tin thanh toán
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu index="12" class="menu-group-invoice" v-if="checkPermission(['electronic-invoice'])">
        <template #title>
          <i class="el-icon-s-order"/>
          <span>Hóa đơn điện tử</span>

        </template>
        <router-link to="/sinvoice/customer-information" class="router-link">
          <el-menu-item
              index="12-1"
              v-if="checkPermission(['electronic invoice-config'])"
              @click="changeBreadcrumbMethod('sinvoice-customer-information')"
          >
            Cấu hình S-Invoice
          </el-menu-item
          >
        </router-link>
        <router-link to="/sinvoice/export-by-class" class="router-link">
          <el-menu-item
              v-if="checkPermission(['electronic-invoice-class'])"
              index="12-2"
              @click="changeBreadcrumbMethod('sinvoice-export-by-class')"
          >Xuất hóa đơn theo lớp
          </el-menu-item
          >
        </router-link>
        <router-link to="/sinvoice/export-by-group" class="router-link">
          <el-menu-item
              v-if="checkPermission(['electronic-invoice-group'])"
              index="12-3"
              @click="changeBreadcrumbMethod('sinvoice-export-by-group')"
          >Xuất hóa đơn theo nhóm
          </el-menu-item
          >
        </router-link>
        <router-link to="/sinvoice/invoice-management" class="router-link">
          <el-menu-item
              v-if="checkPermission(['invoice-management'])"
              index="12-4"
              @click="changeBreadcrumbMethod('invoice-management')"
          >Quản lý hóa đơn học phí
          </el-menu-item
          >
        </router-link>
        <router-link to="/sinvoice/invoice-management-other" class="router-link">
          <el-menu-item
              v-if="checkPermission(['invoice-management'])"
              index="12-5"
              @click="changeBreadcrumbMethod('invoice-management-other')"
          >Quản lý hóa đơn khác
          </el-menu-item
          >
        </router-link>
        <router-link to="/sinvoice/goods-services" class="router-link">
          <el-menu-item
              index="12-6"
              @click="changeBreadcrumbMethod('sinvoice-goods-services')"
          >Hàng hóa, dịch vụ
          </el-menu-item
          >
        </router-link>
        <a
            class="router-link"
            href="https://vinvoice.viettel.vn/account/login"
            target="_blank"
            rel="noopener noreferrer"
            style="color: #bfcbd9; display: block"
        >
          <el-menu-item
              v-if="checkPermission(['electronic invoice-support'])"
              index="12-7"
          >S-InVoice
          </el-menu-item>
        </a>
      </el-submenu>
      <el-submenu index="13" class="menu-group-banking" v-if="checkPermission(['bank-connection-manager'])">
        <template #title>
          <i class="el-icon-money"/>
          <span>Thanh toán trực tuyến</span>
        </template>
        <!--        Version 1-->
        <!--        <router-link to="/school/bank-connection-manager" class="router-link">-->
        <!--          <el-menu-item-->
        <!--              index="13-1"-->
        <!--              @click="changeBreadcrumbMethod('school-bank-connection-manager')"-->
        <!--          >-->
        <!--            Danh sách ngân hàng liên kết-->
        <!--          </el-menu-item>-->
        <!--        </router-link>-->
        <!--        Vesion 2-->
        <router-link to="/school/bank-connection-manager/v2" class="router-link">
          <el-menu-item
              index="13-2"
              @click="changeBreadcrumbMethod('school-bank-connection-manager-v2')"
          >
            Danh sách ngân hàng liên kết
          </el-menu-item>
        </router-link>
        <router-link to="/school/bank-transaction-statistics-school" class="router-link">
          <el-menu-item
              index="13-3"
              @click="changeBreadcrumbMethod('school-bank-transaction-statistics-school')"
          >
            Thống kê lịch sử giao dịch
          </el-menu-item>
        </router-link>
        <router-link to="/school/transaction-volume-chart-school" class="router-link">
          <el-menu-item
              index="13-4"
              @click="changeBreadcrumbMethod('school-transaction-volume-chart-school')"
          >
            Thống kê số lượng giao dịch
          </el-menu-item>
        </router-link>
        <router-link to="/school/student-user-statistics" class="router-link">
          <el-menu-item
              index="13-5"
              @click="changeBreadcrumbMethod('school-student-user-statistics')"
          >
            Danh sách học sinh sử dụng
          </el-menu-item>
        </router-link>
      </el-submenu>
      <el-submenu index="14" class="menu-group-chart"
                  v-if="checkPermission(['statistical'])">
        <template #title>
          <i class="el-icon-s-data"/>
          <span>Thống kê</span>
        </template>
        <el-submenu index="14-1"
                    v-if="checkPermission(['statistical_kids'])">
          <template #title>Học sinh</template>
          <router-link to="/chart/statistical/chart-status" class="router-link">
            <el-menu-item
                v-if="checkPermission(['statistical_kids_status'])"
                index="14-1-1"
                @click="changeBreadcrumbMethod('chart-statistical-status')"
            >Trạng thái
            </el-menu-item
            >
          </router-link>
          <router-link to="/chart/statistical/attendance" class="router-link">
            <el-menu-item
                index="14-1-2"
                v-if="checkPermission(['statistical_kids_attendance'])"
                @click="changeBreadcrumbMethod('chart-statistical-attendance')"
            >Điểm danh
            </el-menu-item
            >
          </router-link>
          <router-link to="/chart/statistical/evaluate" class="router-link">
            <el-menu-item
                index="14-1-3"
                v-if="checkPermission(['statistical_kids_evaluate'])"
                @click="changeBreadcrumbMethod('chart-statistical-evaluate')"
            >Nhận xét
            </el-menu-item
            >
          </router-link>
          <router-link to="/chart/statistical/album" class="router-link">
            <el-menu-item
                index="14-1-4"
                v-if="checkPermission(['statistical_kids_album'])"
                @click="changeBreadcrumbMethod('chart-statistical-album')"
            >Album ảnh
            </el-menu-item
            >
          </router-link>
          <router-link to="/chart/statistical/fees" class="router-link">
            <el-menu-item
                index="14-1-5"
                v-if="checkPermission(['statistical_kids_fees'])"
                @click="changeBreadcrumbMethod('chart-statistical-fees')"
            >Học phí
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <el-submenu index="14-2"
                    v-if="checkPermission(['statistical_employee'])">
          <template #title>Nhân sự</template>
          <router-link
              to="/chart/statistical/chart-status-employee"
              class="router-link"
          >
            <el-menu-item
                v-if="checkPermission(['statistical_employee_status'])"
                index="14-2-1"
                @click="changeBreadcrumbMethod('chart-statistical-status-employee')    "
            >Trạng thái
            </el-menu-item
            >
          </router-link>
          <router-link
              to="/chart/statistical/attendance-employee"
              class="router-link"
          >
            <el-menu-item
                v-if="checkPermission(['statistical_employee_attendance'])"
                index="14-2-2"
                @click="
                changeBreadcrumbMethod('chart-statistical-attendance-employee')
              "
            >Điểm danh
            </el-menu-item
            >
          </router-link>
          <router-link to="/chart/statistical/finace" class="router-link">
            <el-menu-item
                v-if="checkPermission(['statistical_employee_salary'])"
                index="14-2-3"
                @click="changeBreadcrumbMethod('chart-statistical-finace')"
            >Công lương
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <el-submenu index="14-3"
                    v-if="checkPermission(['statistical_internal'])">
          <template #title>Nội bộ</template>
          <router-link
              to="/chart/statistical/cashinternal-paymoney"
              class="router-link"
          >
            <el-menu-item
                index="14-3-1"
                v-if="checkPermission(['statistical_internal_inout'])"
                @click="changeBreadcrumbMethod('chart-statistical-cashinternal-paymoney') "
            >Thu chi
            </el-menu-item
            >
          </router-link>
          <router-link
              to="/chart/statistical/cashinternal-cashbook"
              class="router-link"
          >
            <el-menu-item
                index="14-3-2"
                v-if="checkPermission(['statistical_internal_cashbook'])"
                @click="
                changeBreadcrumbMethod(
                  'chart-statistical-cashinternal-cashbook'
                )
              "
            >Quỹ nhà trường
            </el-menu-item
            >
          </router-link>
          <router-link
              to="/chart/statistical/wallet-parent"
              class="router-link"
          >
            <el-menu-item
                index="14-3-3"
                v-if="checkPermission(['statistical_internal_wallet'])"
                @click="changeBreadcrumbMethod('chart-statistical-wallet-parent')"
            >Ví phụ huynh
            </el-menu-item
            >
          </router-link>
        </el-submenu>
        <el-submenu index="14-4"
                    v-if="checkPermission(['statisticalFinance'])"
        >
          <template #title>
            <span>Thống kê báo cáo</span>
          </template>
          <router-link to="/finace/statistical/money" class="router-link">
            <el-menu-item
                index="14-4-1"
                v-if="checkPermission(['statisticalFinance_statistical'])"
                @click="changeBreadcrumbMethod('finace-statistical-money')"
            >Thống kê
            </el-menu-item
            >
          </router-link>
          <router-link to="/finace/statistical/finance" class="router-link">
            <el-menu-item
                index="14-4-2"
                v-if="checkPermission(['statisticalFinance_money'])"
                @click="changeBreadcrumbMethod('finace-statistical-finance')"
            >Số liệu báo cáo
            </el-menu-item
            >
          </router-link>
          <router-link to="/finace/statistical/kids/group" class="router-link">
            <el-menu-item
                index="14-4-3"
                v-if="checkPermission(['statisticalFinance_groupFees'])"
                @click="changeBreadcrumbMethod('finace-statistical-kids-group')"
            >Nhóm học phí
            </el-menu-item
            >
          </router-link>
          <router-link
              to="/finace/statistical/employee/group"
              class="router-link"
          >
            <el-menu-item
                index="14-4-4"
                v-if="checkPermission(['statisticalFinance_groupSalary'])"
                @click="
                changeBreadcrumbMethod('finace-statistical-employee-group')
              "
            >Nhóm công lương
            </el-menu-item
            >
          </router-link>
        </el-submenu>

      </el-submenu>
      <el-submenu index="15" class="menu-group-birthday"
                  v-if=" checkPermission(['birthday'])">
        <template #title>
          <i class="el-icon-burger"/>
          <span class="title_nav">
           Quản lý sinh nhật
            <span class="title_nav_indicator"
                  v-if="studentBirthday > 0 || parentBirthday > 0 || employeeBirthday > 0"
            >
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>
        <router-link to="/birthday/kids" class="router-link">
          <el-menu-item
              index="15-1"
              v-if="checkPermission(['birthday_kids'])"
              @click="changeBreadcrumbMethod('birthday-kids')"
          >
            <div class="wrap_title_nav">
              <span>Sinh nhật học sinh</span>
              <div v-if="studentBirthday > 0" class="notification_nav">{{ studentBirthday }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/birthday/parent" class="router-link">
          <el-menu-item
              index="15-2"
              v-if="checkPermission(['birthday_parent'])"
              @click="changeBreadcrumbMethod('birthday-parent')"
          >
            <div class="wrap_title_nav">
              <span>Sinh nhật phụ huynh</span>
              <div v-if="parentBirthday > 0" class="notification_nav">{{ parentBirthday }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/birthday/employee" class="router-link">
          <el-menu-item
              index="15-3"
              v-if="checkPermission(['birthday_teacher'])"
              @click="changeBreadcrumbMethod('birthday-employee')"
          >
            <div class="wrap_title_nav">
              <span>Sinh nhật nhân viên</span>
              <div v-if="employeeBirthday > 0" class="notification_nav">{{ employeeBirthday }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu index="16" class="menu-group-history"
                  v-if="checkPermission(['notifyHistory'])"
      >
        <template #title>
          <i class="el-icon-chat-dot-round"/>
          <span class="title_nav">
           Lịch sử thông báo
            <span class="title_nav_indicator"
                  v-if="SMSHistory > 0 || appNotificationHistory > 0"
            >
              <!-- <span class="hue_dot_notification"></span> -->
              <!-- <span class="dot_notification"></span> -->
            </span>
          </span>
        </template>
        <router-link to="/notifihis/schedulesms" class="router-link">
          <el-menu-item
              index="16-1"
              v-if="checkPermission(['notifyHistory_schedule'])"
              @click="changeBreadcrumbMethod('notifihis-schedulesms')"
          >Tin nhắn đặt lịch
          </el-menu-item
          >
        </router-link>

        <router-link to="/notifihis/custom" class="router-link">
          <el-menu-item
              index="16-2"
              v-if="checkPermission(['notifyHistory_custom'])"
              @click="changeBreadcrumbMethod('notifihis-custom')"
          >Tin nhắn tùy chỉnh
          </el-menu-item
          >
        </router-link>
        <router-link to="/notifihis/historysms" class="router-link">
          <el-menu-item
              index="16-3"
              v-if="checkPermission(['notifyHistory_historySms'])"
              @click="changeBreadcrumbMethod('notifihis-historysms')"
          >
            <div class="wrap_title_nav">
              <span>Lịch sử nhắn tin SMS</span>
              <div v-if="SMSHistory > 0" class="notification_nav">{{ SMSHistory }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
        <router-link to="/notifihis/historyapp" class="router-link">
          <el-menu-item
              v-if="checkPermission(['notifyHistory_historyApp'])"
              index="16-4"
              @click="changeBreadcrumbMethod('notifihis-historyapp')"
          >
            <div class="wrap_title_nav">
              <span>Lịch sử thông báo App</span>
              <div v-if="appNotificationHistory > 0" class="notification_nav">{{ appNotificationHistory }}</div>
            </div>
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu index="17" class="menu-group-outschool"
                  v-if="checkPermission(['outSchool'])"
      >
        <template #title>
          <i class="el-icon-s-promotion"/>
          <span>Quản lý ra trường</span>
        </template>
        <router-link to="/group-out/student" class="router-link">
          <el-menu-item
              index="17-1"
              v-if="checkPermission(['outSchool_student'])"
              @click="changeBreadcrumbMethod('group-out-student')"
          >Học sinh
          </el-menu-item
          >
        </router-link>
        <router-link to="/group-out/employee" class="router-link">
          <el-menu-item
              index="17-2"
              v-if="checkPermission(['outSchool_employee'])"
              @click="changeBreadcrumbMethod('group-out-employee')"
          >Nhân sự
          </el-menu-item
          >
        </router-link>
        <router-link to="/group-out/category" class="router-link">
          <el-menu-item
              index="17-3"
              v-if="checkPermission(['outSchool_folder'])"
              @click="changeBreadcrumbMethod('group-out-category')"
          >Thư mục
          </el-menu-item
          >
        </router-link>
      </el-submenu>
      <el-submenu
          index="18" class="menu-group-config"
          v-if="
          checkPermission(['schoolConfig'])
        "
      >
        <template #title>
          <i class="el-icon-setting"/>
          <span>Cấu hình nhà trường</span>
        </template>
        <router-link
            v-if="checkPermission(['schoolConfig_school'])"
            to="/school/infor"
            class="router-link"
        >
          <el-menu-item index="18-1" @click="changeBreadcrumbMethod('school-infor')"
          >Thông tin trường
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_absentTeacher'])"
            to="/school/config-class"
            class="router-link"
        >
          <el-menu-item
              index="18-2"
              @click="changeBreadcrumbMethod('school-config-class')"
          >Cấu hình ngày nghỉ
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_attendanceEmployee'])"
            to="/school/config-employee"
            class="router-link"
        >
          <el-menu-item
              index="18-3"
              @click="changeBreadcrumbMethod('school-config-employee')"
          >Cấu hình nhân sự
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_finance'])"
            to="/school/config-common"
            class="router-link"
        >
          <el-menu-item
              index="18-4"
              @click="changeBreadcrumbMethod('school-config-common')"
          >Cấu hình tài chính
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['register-shift-subject'])"
            to="/school/register-shift-subject"
            class="router-link"
        >
          <el-menu-item
              index="18-5"
              @click="changeBreadcrumbMethod('register-shift-subject')"
          >Đăng ký khung giờ học
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['shift-master'])"
            to="/school/shift-master"
            class="router-link"
        >
          <el-menu-item
              index="18-6"
              @click="changeBreadcrumbMethod('shift-master')"
          >Thiết lập khung giờ học
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_print'])"
            to="/school/config-print"
            class="router-link"
        >
          <el-menu-item
              index="18-7"
              @click="changeBreadcrumbMethod('school-config-print')"
          >Cấu hình in
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_subject'])"
            to="/school/subject"
            class="router-link"
        >
          <el-menu-item index="18-8" @click="changeBreadcrumbMethod('school-subject')"
          >Quản lý môn học
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_attendanceSample'])"
            to="/school/attendance-sample"
            class="router-link"
        >
          <el-menu-item
              index="18-9"
              @click="changeBreadcrumbMethod('school-attendance-sample')"
          >Mẫu điểm danh
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_evaluateSample'])"
            to="/school/evaluate-sample"
            class="router-link"
        >
          <el-menu-item
              index="18-10"
              @click="changeBreadcrumbMethod('school-evaluate-sample')"
          >Mẫu nhận xét
          </el-menu-item
          >
        </router-link>

        <router-link
            v-if="checkPermission(['schoolConfig_wishSample'])"
            to="/school/wish-sample"
            class="router-link"
        >
          <el-menu-item index="18-11" @click="changeBreadcrumbMethod('school-wish-sample')"
          >Mẫu lời chúc
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_accountType'])"
            to="/school/account-type"
            class="router-link"
        >
          <el-menu-item
              index="18-12"
              @click="changeBreadcrumbMethod('school-account-type')"
          >Quản lý đối tượng
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['schoolConfig_cameraSchool'])"
            to="/school/camera-school"
            class="router-link"
        >
          <el-menu-item
              index="18-13"
              @click="changeBreadcrumbMethod('school-camera-school')"
          >Quản lý camera
          </el-menu-item
          >
        </router-link>


        <router-link
            to="/school/icon-app"
            class="router-link"
        >
          <el-menu-item
              index="18-14"
              @click="changeBreadcrumbMethod('icon-app-school')"
          >Quản lý Icon App
          </el-menu-item
          >
        </router-link>
        <router-link
            v-if="checkPermission(['recognition-manager'])"
            to="/school/recognition-manager"
            class="router-link"
        >
          <el-menu-item
              index="18-15"
              @click="changeBreadcrumbMethod('school-config-recognition-manager')"
          >Quản lý nhận diện AI
          </el-menu-item
          >
        </router-link>

        <router-link
            to="/school/chat-group"
            class="router-link"
        >
          <el-menu-item
              index="18-16"
              @click="changeBreadcrumbMethod('chat-group')"
          >Cấu hình Chat
          </el-menu-item
          >
        </router-link>

      </el-submenu>
      <el-submenu index="19" class="menu-group-support">
        <template #title>
          <i class="el-icon-question"/>
          <span>Hỗ trợ &amp; hướng dẫn</span>
        </template>
        <a
            v-for="item in supportList"
            :key="item.name"
            class="router-link"
            :href="item.link"
            target="_blank"
            style="color: #bfcbd9; display: block"
        >
          <el-menu-item :index="item.name">{{ item.name }}</el-menu-item>
        </a>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import checkPermission from "@/utils/permission";
import {mapGetters, mapState} from "vuex";

export default {
  name: 'MenuSchool',
  data() {
    return {
      breadcrumbDataList: [
        //bản tin
        {
          key: "appsend-notification",
          value: [{url: "/appsend/notification", name: "Thông báo hệ thống"}],
        },
        {
          key: "appsend-parent-feedback",
          value: [{url: "/appsend/parent-feedback", name: "Phụ huynh góp ý"}],
        },
        {
          key: "appsend-teacher-feedback",
          value: [{url: "/appsend/teacher-feedback", name: "Giáo viên góp ý"}],
        },
        {
          key: "survey-form-manager",
          value: [
            {url: "/survey_form/manager", name: "Phiếu khảo sát"}
          ],
        },
        //nhật ký phụ huynh
        {
          key: "parentdiary-message-parent",
          value: [{url: "/parentdiary/message-parent", name: "Lời nhắn"}],
        },
        {
          key: "parentdiary-medicine",
          value: [{url: "/parentdiary/medicine", name: "Dặn thuốc"}],
        },
        {
          key: "parentdiary-take-leave",
          value: [{url: "/parentdiary/take-leave", name: "Xin nghỉ"}],
        },
        {
          key: "absent-letter_v4",
          value: [{
            url: "/absent_letter/daily",
            name: "Xin nghỉ"
          }]
        },
        //quản lý nhân sự
        {
          key: "employee-department",
          value: [{url: "/employee/department", name: "Danh sách phòng ban"}],
        },
        {
          key: "employee-employees",
          value: [{url: "/employee/employees", name: "Danh sách nhân sự"}],
        },
        //danh sách học sinh
        {
          key: "student-grade",
          value: [{url: "/student/grade", name: "Danh sách khối"}],
        },
        {
          key: "student-class",
          value: [{url: "/student/class", name: "Danh sách lớp"}],
        },
        {
          key: "student-students",
          value: [{url: "/student/students", name: "Danh sách học sinh"}],
        },
        {
          key: "parent_manager",
          value: [
            {
              url: "/parent/manager",
              name: "Danh sách phụ huynh",
            }
          ]
        },
        {
          key: "student-students-group",
          value: [{url: "/student/students-group", name: "Nhóm học sinh"}],
        },
        //chất lượng học sinh
        {
          key: "student-quality-attendance",
          value: [{url: "/student-quality/attendance", name: "Điểm danh"}],
        },
        {
          key: "student-quality-attendance_v2",
          value: [{url: "/student-quality/attendance/v2", name: "Điểm danh"}],
        },
        {
          key: "attendance-v4",
          value: [{
            url: "/attendance/daily",
            name: "Điểm danh"
          }]
        },
        {
          key: "attendance-class-v3",
          value: [{url: "/student-quality/attendance-class-v3", name: "Điểm danh theo lớp"}],
        },
        {
          key: "attendance-group-v3",
          value: [{url: "/student-quality/attendance-group-v3", name: "Điểm danh theo nhóm"}],
        },
        {
          key: "student-quality-evaluate",
          value: [{url: "/student-quality/evaluate", name: "Nhận xét"}],
        },
        {
          key: "student-evaluation-v4",
          value: [{url: "/evaluation-v4", name: "Nhận xét"}],
        },
        {
          key: "student-quality-album",
          value: [{url: "/album-v2", name: "Album ảnh"}],
        },
        {
          key: "student-quality-height-weight",
          value: [
            {
              url: "/student-quality/height-weight",
              name: "Chiều cao, cân nặng",
            },
          ],
        },
        {
          key: "student-quality-schedule",
          value: [{url: "/student-quality/schedule", name: "Thời khóa biểu"}],
        },
        {
          key: "student-quality-class-menu",
          value: [{url: "/student-quality/class-menu", name: "Thực đơn"}],
        },
        {
          key: "student-quality-lifecycle",
          value: [{url: "/student-quality/lifecycle", name: "Lịch sử học sinh"}],
        },
        //Học phí dịch vụ I
        {
          key: "finance-fees-order-excel",
          value: [{url: "/finance/v2", name: "Thu học phí theo lớp"}],
        },
        {
          key: "finance-fees-order-excel-group",
          value: [{url: "/finance/tuition-group-by-excel", name: "Thu học phí theo nhóm"}],
        },
        {
          key: "finance-tuition-statistics",
          value: [{url: " /finance/tuition-statistics", name: "Thống kê học phí"}],
        },
        {
          key: "finance-tuition-statistics-charts",
          value: [{url: "/finance/tuition-statistics/charts", name: "Biểu đồ thống kê"}],
        },
        {
          key: "finance-manage-tuition-management",
          value: [{url: "/finance/manage/tuition-management", name: "Danh sách khoản"}],
        },
        {
          key: "finance-manage-register-revenue",
          value: [{url: "/finance/manage/register-revenue", name: "Đăng ký khoản"}],
        },
        {
          key: "finance-manage-initialize-class-tuition",
          value: [{url: "/finance/manage/initialize-class-tuition", name: "Duyệt khoản học phí lớp"}],
        },
        {
          key: "finance-manage-initialize-group-tuition",
          value: [{url: "/finance/manage/initialize-class-tuition", name: "Duyệt khoản học phí nhóm"}],
        },

        //học phí & dịch vụ II
        {
          key: "finace-fees-order",
          value: [{url: "/finace/fees/order", name: "Thu học phí"}],
        },
        {
          key: "finace-fees-approved",
          value: [{url: "/finace/fees/approved", name: "Duyệt học phí"}],
        },
        {
          key: "finace-fees-package-kids",
          value: [{url: "/finace/fees/package-kids", name: "Đăng ký khoản"}],
        },
        {
          key: "finace-fees-package",
          value: [{url: "/finace/fees/package", name: "Danh sách khoản"}],
        },
        {
          key: "finace-fees-wallet",
          value: [{url: "/finace/fees/wallet", name: "Quản lý ví"}],
        },
        /**
         * Quản lý học phí gói
         * */
        {
          key: "finance-manage-packages",
          value: [
            {
              url: "/finance/manage/packages",
              name: "Quản lý học phí gói",
            }
          ]
        },
        {
          key: "finance-manage-v3-packages",
          value: [{url: "/finance/manage-v3/packages", name: "Danh sách gói học phí"}],
        },
        {
          key: "finance-manage-v3-principal-revenues",
          value: [{url: "/finance/manage-v3/principal-revenues", name: "Danh sách khoản phụ"}],
        },
        {
          key: "finance-manage-v3-tuition-statistics",
          value: [{url: "/finance/manage-v3/principal-revenues", name: "Thống kê phiếu thu"}],
        },
        {
          key: "finance-manage-v3-tuition-statistics-charts",
          value: [{url: "/finance/manage-v3/principal-revenues", name: "Biểu đồ thống kê"}],
        },
        {
          key: "finance-manage-v3-revenue-scopes",
          value: [{url: "/finance/manage-v3/revenue-scopes", name: "Đăng ký  lớp/nhóm/gói"}],
        },
        {
          key: "finance-manage-v3-total-revenues",
          value: [{url: "/finance/manage-v3/total-revenues", name: "Danh sách khoản chính"}],
        },

        {
          key: "finance-manage-v3-managing-revenue",
          value: [{url: "/finance/manage-v3/managing-revenue", name: "Đăng ký khoản sử dụng"}],
        },

        {
          key: "finance-manage-v3-draft-invoice",
          value: [{url: "/finance/manage-v3/draft-invoice", name: "Duyệt học phí"}],
        },

        {
          key: "finance-manage-v3-student-invoices",
          value: [{url: "/finance/manage-v3/student-invoices", name: "Thu học phí"}],
        },
        {
          key: "finance-manage-v3-student-invoice-summary",
          value: [{url: "/finance/manage-v3/student-invoice-summary", name: "Tổng hợp phiếu thu"}],
        },

        //Công lương
        {
          key: "finace-salary-attendance",
          value: [{url: "/finace/salary/attendance", name: "Chấm công nhân viên"}],
        },
        {
          key: "attendance-employee-v3",
          value: [{url: "/finace/salary/attendance-employee-v3", name: "Chấm công nhân viên"}],
        },
        {
          key: "finace-salary-absent",
          value: [{url: "/finace/salary/absent", name: "Quản lý xin nghỉ"}],
        },
        {
          key: "finace-salary-paid",
          value: [{url: "/finace/salary/paid", name: "Thanh toán lương"}],
        },
        {
          key: "finace-salary-approved",
          value: [{url: "/finace/salary/approved", name: "Duyệt bảng lương"}],
        },
        {
          key: "finace-salary-institute",
          value: [{url: "/finace/salary/institute", name: "Thiết lập tiền lương"}],
        },
        {
          key: "finace-salary-attendance-config",
          value: [
            {
              url: "/finace/salary/attendance-config",
              name: "Thiết lập chấm công",
            },
          ],
        },
        {
          key: "finace-salary-sample",
          value: [{url: "/finace/salary/sample", name: "Mẫu công lương"}],
        },
        {
          key: "finance-salary-statistical",
          value: [{url: "/finance/salary/statistical", name: "Thống kê công lương"}],
        },
        //thu chi nội bộ
        {
          key: "finance-employee-salary-new",
          value: [{url: "finance/employee/salary/new", name: "Bảng lương"}],
        },
        {
          key: "finance-employee-static-salary-new",
          value: [{url: "/finance/employee/static-salary/new", name: "Biểu đồ công lương"}],
        },
        {
          key: "finace-cashinternal-paymoney",
          value: [{url: "/finace/cashinternal/paymoney", name: "Quản lý phiếu chi"}],
        },
        {
          key: "finace-cashinternal-collectmoney",
          value: [
            {
              url: "/finace/cashinternal/collectmoney",
              name: "Quản lý phiếu thu",
            },
          ],
        },
        {
          key: "finace-cashinternal-cashbook",
          value: [{url: "/finace/cashinternal/cashbook", name: "Quản lý quỹ"}],
        },
        {
          key: "finace-cashinternal-peopletype",
          value: [
            {
              url: "/finace/cashinternal/peopletype",
              name: "Danh sách đối tượng",
            },
          ],
        },
        {
          key: "finace-cashinternal-bankinfo",
          value: [
            {
              url: "/finace/cashinternal/bankinfo",
              name: "Thông tin thanh toán",
            },
          ],
        },
        {
          key: "sinvoice-customer-information",
          value: [
            {
              url: "/sinvoice/customer-information",
              name: "Cấu hình S-Invoice",
            },
          ],
        },
        {
          key: "sinvoice-export-by-class",
          value: [
            {
              url: "/sinvoice/export-by-class",
              name: "Xuất hóa đơn theo lớp",
            },
          ],
        },
        {
          key: "sinvoice-export-by-group",
          value: [
            {
              url: "/sinvoice/export-by-group",
              name: "Xuất hóa đơn theo nhóm",
            },
          ],
        },
        {
          key: "invoice-management",
          value: [
            {
              url: "/sinvoice/invoice-management",
              name: "Quản lý hóa đơn học phí",
            },
          ],
        },
        {
          key: "invoice-management-other",
          value: [
            {
              url: "/sinvoice/invoice-management-other",
              name: "Quản lý hóa đơn khác",
            },
          ],
        },
        {
          key: "sinvoice-goods-services",
          value: [
            {
              url: "/sinvoice/goods-services",
              name: "Hàng hóa, dịch vụ",
            },
          ],
        },
        //quản lý sinh nhật
        {
          key: "birthday-kids",
          value: [{url: "/birthday/kids", name: "Sinh nhật học sinh"}],
        },
        {
          key: "birthday-parent",
          value: [{url: "/birthday/parent", name: "Sinh nhật phụ huynh"}],
        },
        {
          key: "birthday-employee",
          value: [{url: "/birthday/employee", name: "Sinh nhật nhân viên"}],
        },
        //thống kê báo cáo
        {
          key: "finace-statistical-money",
          value: [{url: "/finace/statistical/money", name: "Thống kê"}],
        },
        {
          key: "finace-statistical-kids-group",
          value: [{url: "/finace/statistical/kids/group", name: "Nhóm học phí"}],
        },
        {
          key: "finace-statistical-finance",
          value: [{url: "/finace/statistical/finance", name: "Số liệu báo cáo"}],
        },
        {
          key: "finace-statistical-employee-group",
          value: [
            {
              url: "/finace/statistical/employee/group",
              name: "Nhóm công lương",
            },
          ],
        },
        //thống kê biểu đồ
        {
          key: "chart-statistical-status",
          value: [{url: "/chart/statistical/chart-status", name: "Trạng thái"}],
        },
        {
          key: "chart-statistical-attendance",
          value: [{url: "/chart/statistical/attendance", name: "Điểm danh"}],
        },
        {
          key: "chart-statistical-evaluate",
          value: [{url: "/chart/statistical/evaluate", name: "Nhận xét"}],
        },
        {
          key: "chart-statistical-album",
          value: [{url: "/chart/statistical/album", name: "Album ảnh"}],
        },
        {
          key: "chart-statistical-fees",
          value: [{url: "/chart/statistical/fees", name: "Học phí"}],
        },
        {
          key: "chart-statistical-status-employee",
          value: [
            {
              url: "/chart/statistical/chart-status-employee",
              name: "Trạng thái",
            },
          ],
        },
        {
          key: "chart-statistical-attendance-employee",
          value: [
            {
              url: "/chart/statistical/attendance-employee",
              name: "Điểm danh",
            },
          ],
        },
        {
          key: "chart-statistical-finace",
          value: [{url: "/chart/statistical/finnace", name: "Công lương"}],
        },
        {
          key: "chart-statistical-cashinternal-paymoney",
          value: [
            {
              url: "/chart/statistical/cashinternal-paymoney",
              name: "Thu chi",
            },
          ],
        },
        {
          key: "chart-statistical-cashinternal-cashbook",
          value: [
            {
              url: "/chart/statistical/cashinternal-cashbook",
              name: "Quỹ nhà trường",
            },
          ],
        },
        {
          key: "chart-statistical-wallet-parent",
          value: [{url: "/chart/statistical/wallet-parent", name: "Ví phụ huynh"}],
        },

        //lịch sử thông báo
        {
          key: "notifihis-schedulesms",
          value: [{url: "/notifihis/schedulesms", name: "Tin nhắn đặt lịch"}],
        },
        {
          key: "notifihis-custom",
          value: [{url: "/notifihis/custom", name: "Tin nhắn tùy chỉnh"}],
        },
        {
          key: "notifihis-historysms",
          value: [{url: "/notifihis/historysms", name: "Lịch sử nhắn tin SMS"}],
        },
        {
          key: "notifihis-historyapp",
          value: [{url: "/notifihis/historyapp", name: "Lịch sử thông báo App"}],
        },
        {
          key: "notifihis-notify-school",
          value: [{url: "/notifihis/notify-school", name: "Tin tức nhà trường"}],
        },
        //thống kê chung
        //Quản lý ra trường
        {
          key: "group-out-student",
          value: [
            {
              url: "/group-out/student",
              name: "Quản lý ra trường học sinh",
            },
          ],
        },
        {
          key: "group-out-employee",
          value: [
            {
              url: "/group-out/employee",
              name: "Quản lý ra trường nhân sự",
            },
          ],
        },
        {
          key: "group-out-category",
          value: [{url: "/group-out/category", name: "Quản lý thư mục"}],
        },
        //Cấu hình nhà trường
        {
          key: 'school-config-print',
          value: [{url: "/school/config-print", name: "Cấu hình in ấn"}],
        },
        {
          key: "school-infor",
          value: [{url: "/school/infor", name: "Thông tin trường"}],
        },
        {
          key: "school-config",
          value: [{url: "/school/config", name: "Cấu hình chung"}],
        },
        {
          key: "school-config-class",
          value: [{url: "/school/config-class", name: "Cấu hình ngày nghỉ"}],
        },
        {
          key: "school-config-employee",
          value: [{url: "/school/config-employee", name: "Cấu hình nhân sự"}],
        },
        {
          key: "school-config-common",
          value: [{url: "/school/config-common", name: "Cấu hình tài chính"}],
        },
        {
          key: "register-shift-subject",
          value: [{url: "/school/register-shift-subject", name: "Đăng ký khung giờ học"}],
        },
        {
          key: "shift-master",
          value: [{url: "/school/shift-master", name: "Thiết lập khung giờ học"}],
        },
        {
          key: "school-camera-school",
          value: [{url: "/school/camera-type", name: "Quản lý camera"}],
        },
        {
          key: "icon-app-school",
          value: [{url: "/school/icon-app", name: "Quản lý Icon App"}],
        },
        {
          key: "school-config-recognition-manager",
          value: [{url: "/school/recognition-manager", name: "Quản lý nhận diện AI"}],
        },
        {
          key: "chat-group",
          value: [{url: "/school/chat-group", name: "Cấu hình chat"}],
        },
        {
          key: "school-media",
          value: [{url: "/school/media", name: "Cấu hình Media"}],
        },
        {
          key: "school-notification-manage",
          value: [{url: "/school/notification-manage", name: "Tự động gửi tin"}],
        },
        {
          key: "school-config-fuction",
          value: [{url: "/school/config-fuction", name: "Ẩn hiển chức năng"}],
        },
        {
          key: "school-birthday-sample",
          value: [{url: "/school/birthday-sample", name: "Cấu hình gửi tin"}],
        },
        {
          key: "school-subject",
          value: [{url: "/school/subject", name: "Quản lý môn học"}],
        },
        {
          key: "school-evaluate-sample",
          value: [{url: "/school/evaluate-sample", name: "Mẫu nhận xét"}],
        },
        {
          key: "school-attendance-sample",
          value: [
            {
              url: "/school/attendance-sample",
              name: "Mẫu điểm danh",
            },
          ],
        },
        {
          key: "school-wish-sample",
          value: [
            {
              url: "/school/wish-sample",
              name: "Mẫu lời chúc",
            },
          ],
        },
        {
          key: "school-account-type",
          value: [{url: "/school/account-type", name: "Quản lý đối tượng"}],
        },
        {
          key: "school-bank-connection-manager",
          value: [{url: "/school/bank-connection-manager", name: "Danh sách ngân hàng liên kết"}],
        },
        {
          key: "school-bank-connection-manager-v2",
          value: [{url: "/school/bank-connection-manager/v2", name: "Danh sách ngân hàng liên kết"}],
        },
        {
          key: "school-bank-transaction-statistics-school",
          value: [{url: "/school/bank-transaction-statistics-school", name: "Thống kê lịch sử giao dịch"}],
        },
        {
          key: "school-transaction-volume-chart-school",
          value: [{url: "/school/transaction-volume-chart-school", name: "Thống kê số lượng giao dịch"}],
        },
        {
          key: "school-student-user-statistics",
          value: [{url: "/school/student-user-statistics", name: "Danh sách học sinh sử dụng"}],
        },
      ],
    }

  },
  created() {
    this.$store.dispatch('commonDataStore/fetchDataSupportList');
  },
  computed: {
    getIsOpenCloseManu() {
      return this.$store.getters["layout/getIsOpenClose"];
    },
    getAppTypeUserLogin() {
      return this.$store.state.auth.user.appType;
    },
    ...mapGetters('commonDataStore', ['supportList']),
    ...mapState('notificationNavbarStore', [
      "activeMenuIndex",
      "openSubMenu",
      "parentMessage",
      "medicationInstructions",
      "leaveStudent",
      "parentFeedback",
      "teacherFeedback",
      "commentStudent",
      "pictureAlbum",
      "tuitionV4",
      "tuitionClass",
      "tuitionGroup",
      "payroll",
      "leavePersonnel",
      "paymentVouchers",
      "receipts",
      "studentBirthday",
      "parentBirthday",
      "employeeBirthday",
      "SMSHistory",
      "appNotificationHistory",
    ]),
  },
  methods: {
    checkPermission,
    handleMenuSelect(index, indexPath) {
      // Lưu vị trí scroll của sidebar trước khi store cập nhật
      const sidebar = document.querySelector('.sidebar-wrapper');
      const savedScrollTop = sidebar ? sidebar.scrollTop : 0;

      // Lưu toàn bộ các submenu cha (bỏ phần tử cuối là menu-item được click)
      const openSubMenuList = (indexPath || []).slice(0, -1);
      this.$store.dispatch("notificationNavbarStore/handleActiveSubmenu", {
        menuIndex: openSubMenuList,
        menuItemIndex: index,
      });

      // Khôi phục vị trí scroll sau khi Vue re-render
      this.$nextTick(() => {
        if (sidebar) sidebar.scrollTop = savedScrollTop;
      });
    },
    changeBreadcrumbMethod(val) {
      let selectUrl = this.breadcrumbDataList.filter((x) => x.key === val);
      if (selectUrl.length > 0) {
        let dataList = selectUrl[0].value;
        sessionStorage.setItem("breadcrumbList", JSON.stringify(dataList));
        this.$store.dispatch("layout/setBreadcrumbActions", dataList);
      }
    },

  },

}
</script>

<style lang="scss" scoped>
/* ===== MENU CONTAINER ===== */
.menu-main {
  min-height: 950px;
  padding: 10px 12px 16px;
  background: radial-gradient(circle at top left, rgba(157, 197, 255, 0.28), transparent 28%),
  radial-gradient(circle at 100% 12%, rgba(255, 196, 214, 0.22), transparent 24%),
  radial-gradient(circle at 50% 100%, rgba(186, 242, 219, 0.18), transparent 26%),
  linear-gradient(180deg, #f9fbff 0%, #f3f7ff 52%, #eef4fb 100%);
}

/* ===== MAIN MENU ===== */
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 260px;
  min-height: 700px;
  font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  border-right: none !important;
  border-radius: 18px;
  overflow: hidden;
}

/deep/ .el-menu--collapse {
  border-radius: 18px;
  overflow: hidden;
}

/* ===== ROUTER LINK ===== */
.router-link {
  text-decoration: none;
}

/* ===== LOGO / HOME ITEM ===== */
.el-menu-item.menu-logo-item {
  background: linear-gradient(135deg, #eef2ff 0%, #e3efff 52%, #f5e8ff 100%) !important;
  border-bottom: 1px solid #d7e3ff !important;
  height: 60px !important;
  line-height: normal !important;
  margin-bottom: 6px;
  box-shadow: inset 0 -1px 0 rgba(123, 151, 220, 0.12);
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  &:hover {
    background: linear-gradient(135deg, #e8f0ff 0%, #dbebff 50%, #f0e4ff 100%) !important;
    border-left-color: transparent !important;
  }
}

.menu-logo-icon {
  color: #5b7fd8 !important;
  font-size: 20px !important;
  background: linear-gradient(135deg, rgba(91, 127, 216, 0.16), rgba(173, 114, 255, 0.14));
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}

/deep/ .el-menu--collapse .menu-logo-icon {
  margin-right: 0 !important;
}

.onekids-title {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 1.2px;
  color: #2f436d !important;
  text-transform: uppercase;
}

/* ===== SUBMENU TITLE ===== */
/deep/ .el-submenu__title {
  height: 48px !important;
  line-height: 48px !important;
  font-size: 14px !important;
  font-weight: 600;
  color: #5f6f8f !important;
  border-left: 3px solid transparent;
  border-radius: 12px;
  margin: 4px 8px;
  transition: all 0.25s ease;

  i {
    color: var(--menu-accent, #7e91b2) !important;
    font-size: 15px;
    margin-right: 8px;
    transition: color 0.2s ease;
  }

  > i:first-child {
    width: 28px;
    height: 28px;
    border-radius: 10px;
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--menu-accent-soft, rgba(93, 131, 221, 0.12));
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.14));
  }

  &:hover {
    background: linear-gradient(90deg, var(--menu-hover-start, #eff5ff) 0%, var(--menu-hover-end, #e8f0ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;

    i {
      color: var(--menu-accent-strong, #5d83dd) !important;
    }
  }
}

/* Active (open) submenu title */
/deep/ .el-submenu.is-opened > .el-submenu__title {
  background: linear-gradient(90deg, var(--menu-open-start, #edf4ff) 0%, var(--menu-open-end, #e5efff) 100%) !important;
  color: #2f436d !important;
  border-left: 3px solid var(--menu-accent, #6d96f5) !important;

  i {
    color: var(--menu-accent-strong, #5d83dd) !important;
  }
}

/* ===== MENU ITEMS ===== */
.el-menu-item {
  background-color: transparent !important;
  height: 40px !important;
  line-height: 40px !important;
  font-size: 14px !important;
  color: #6c7b98 !important;
  border-left: 3px solid transparent !important;
  padding-left: 46px !important;
  border-radius: 10px !important;
  margin: 2px 8px !important;
  transition: all 0.22s ease;

  &:hover {
    background: linear-gradient(90deg, var(--menu-item-hover-start, #f2f7ff) 0%, var(--menu-item-hover-end, #eaf1ff) 100%) !important;
    color: #324b78 !important;
    border-left-color: var(--menu-accent, #7aa8ff) !important;
  }

  &.is-active {
    background: linear-gradient(90deg, var(--menu-active-start, #dfeaff) 0%, var(--menu-active-end, #d4e2ff) 100%) !important;
    color: #29456f !important;
    border-left: 3px solid var(--menu-accent-strong, #5d83dd) !important;
    font-weight: 600;
    box-shadow: inset 0 0 0 1px var(--menu-accent-border, rgba(93, 131, 221, 0.12));
  }
}

/* Nested submenu items (level 3) */
/deep/ .el-submenu .el-submenu .el-menu-item {
  padding-left: 60px !important;
  background-color: #f6f9ff !important;
  font-size: 12.5px !important;
  height: 38px !important;
  line-height: 38px !important;
}

/* ===== EL-MENU ROOT ===== */
.el-menu {
  margin-bottom: 20px;
  border: 1px solid #e2eaf7 !important;
  box-shadow: 0 10px 30px rgba(65, 84, 118, 0.08);
  background: rgba(255, 255, 255, 0.82) !important;
  backdrop-filter: blur(6px);
}

/* ===== SUBMENU ARROW ===== */
/deep/ .el-submenu__icon-arrow {
  color: #8b9aba !important;
  font-size: 11px;
  right: 12px;
}

/* ===== NOTIFICATION DOT (submenu title) ===== */
.title_nav {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.title_nav_indicator {
  display: inline-block;
}

.hue_dot_notification,
.dot_notification {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #ff5370;
  z-index: 1;
  border-radius: 50%;
  top: -3px;
  left: -13px;
}

.hue_dot_notification {
  animation: ping 1.2s cubic-bezier(0, 0, 0.2, 1) infinite;
}

/* ===== NOTIFICATION BADGE (menu items) ===== */
.wrap_title_nav {
  display: flex;
  align-items: center;
  gap: 8px;
}

.notification_nav {
  min-width: 18px;
  height: 18px;
  font-size: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff6b88, #ec4b6d);
  border-radius: 9px;
  padding: 0 4px;
  color: #fff;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(255, 83, 112, 0.45);
  line-height: 1;
}

.menu-group-news {
  --menu-accent: #6f8cff;
  --menu-accent-strong: #5574e8;
  --menu-accent-soft: rgba(111, 140, 255, 0.16);
  --menu-accent-border: rgba(111, 140, 255, 0.18);
  --menu-hover-start: #f2f5ff;
  --menu-hover-end: #ebefff;
  --menu-open-start: #edf2ff;
  --menu-open-end: #e6edff;
  --menu-item-hover-start: #f3f6ff;
  --menu-item-hover-end: #edf1ff;
  --menu-active-start: #e3ebff;
  --menu-active-end: #dbe5ff;
}

.menu-group-diary {
  --menu-accent: #5b9df6;
  --menu-accent-strong: #3f83df;
  --menu-accent-soft: rgba(91, 157, 246, 0.16);
  --menu-accent-border: rgba(91, 157, 246, 0.18);
  --menu-hover-start: #eef7ff;
  --menu-hover-end: #e5f1ff;
  --menu-open-start: #e7f4ff;
  --menu-open-end: #deeeff;
  --menu-item-hover-start: #eef7ff;
  --menu-item-hover-end: #e4f0ff;
  --menu-active-start: #dff0ff;
  --menu-active-end: #d4ebff;
}

.menu-group-staff,
.menu-group-salary {
  --menu-accent: #a56df5;
  --menu-accent-strong: #8a50e2;
  --menu-accent-soft: rgba(165, 109, 245, 0.15);
  --menu-accent-border: rgba(165, 109, 245, 0.18);
  --menu-hover-start: #f7f0ff;
  --menu-hover-end: #f1e8ff;
  --menu-open-start: #f2e9ff;
  --menu-open-end: #ebddff;
  --menu-item-hover-start: #f7f0ff;
  --menu-item-hover-end: #f0e6ff;
  --menu-active-start: #ece0ff;
  --menu-active-end: #e3d3ff;
}

.menu-group-student,
.menu-group-quality,
.menu-group-birthday {
  --menu-accent: #ff9f43;
  --menu-accent-strong: #f08a20;
  --menu-accent-soft: rgba(255, 159, 67, 0.16);
  --menu-accent-border: rgba(255, 159, 67, 0.2);
  --menu-hover-start: #fff7ee;
  --menu-hover-end: #ffefdf;
  --menu-open-start: #fff2e4;
  --menu-open-end: #ffe8d0;
  --menu-item-hover-start: #fff7ee;
  --menu-item-hover-end: #ffefdf;
  --menu-active-start: #ffeccf;
  --menu-active-end: #ffe2bb;
}

.menu-group-fees,
.menu-group-cash,
.menu-group-banking {
  --menu-accent: #2fbf8f;
  --menu-accent-strong: #1fa67a;
  --menu-accent-soft: rgba(47, 191, 143, 0.16);
  --menu-accent-border: rgba(47, 191, 143, 0.18);
  --menu-hover-start: #eefcf7;
  --menu-hover-end: #e4f9f0;
  --menu-open-start: #e6f8f0;
  --menu-open-end: #dcf4ea;
  --menu-item-hover-start: #eefcf7;
  --menu-item-hover-end: #e3f8ef;
  --menu-active-start: #d7f4ea;
  --menu-active-end: #caf0e3;
}

.menu-group-attendance,
.menu-group-config,
.menu-group-support {
  --menu-accent: #4bb6c9;
  --menu-accent-strong: #2a9dad;
  --menu-accent-soft: rgba(75, 182, 201, 0.16);
  --menu-accent-border: rgba(75, 182, 201, 0.18);
  --menu-hover-start: #eefbfd;
  --menu-hover-end: #e3f7fa;
  --menu-open-start: #e6f7fb;
  --menu-open-end: #d9f2f7;
  --menu-item-hover-start: #eefbfd;
  --menu-item-hover-end: #e2f6fa;
  --menu-active-start: #d8f0f5;
  --menu-active-end: #caebf2;
}

.menu-group-invoice,
.menu-group-history {
  --menu-accent: #f36b8a;
  --menu-accent-strong: #df4f71;
  --menu-accent-soft: rgba(243, 107, 138, 0.14);
  --menu-accent-border: rgba(243, 107, 138, 0.18);
  --menu-hover-start: #fff1f5;
  --menu-hover-end: #ffe7ee;
  --menu-open-start: #ffeaf0;
  --menu-open-end: #ffe0e9;
  --menu-item-hover-start: #fff2f6;
  --menu-item-hover-end: #ffe7ee;
  --menu-active-start: #ffdfe8;
  --menu-active-end: #ffd2de;
}

.menu-group-chart,
.menu-group-outschool {
  --menu-accent: #8b7cf6;
  --menu-accent-strong: #7161e8;
  --menu-accent-soft: rgba(139, 124, 246, 0.15);
  --menu-accent-border: rgba(139, 124, 246, 0.18);
  --menu-hover-start: #f4f2ff;
  --menu-hover-end: #ebe8ff;
  --menu-open-start: #efebff;
  --menu-open-end: #e6e0ff;
  --menu-item-hover-start: #f4f2ff;
  --menu-item-hover-end: #ece8ff;
  --menu-active-start: #e5deff;
  --menu-active-end: #dbd2ff;
}

@media (max-width: 1200px) {
  .menu-main {
    padding: 8px;
  }
}

/* ===== PING ANIMATION ===== */
@keyframes ping {
  75%, 100% {
    transform: scale(2.2);
    opacity: 0;
  }
}

/* ===== MESSAGE BOX ===== */
/deep/ .el-message-box {
  display: inline-block;
  vertical-align: top !important;
  width: 420px;
  padding-bottom: 10px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  font-size: 18px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
  overflow: hidden;
  backface-visibility: hidden;
}

/deep/ .el-message-box__wrapper::after {
  content: "";
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: top !important;
}
</style>
